module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "panel-title big-title"
  }, [_vm._v("\n            Rapport de match\n        ")]), _vm._v(" "), (_vm.matchReport && _vm.teamReport) ? [_c('wizard', {
    attrs: {
      "step": _vm.real_step,
      "isDB": false
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-3 columns text-centered panel-title team-name"
  }, [_vm._v("\n                    " + _vm._s(_vm.team.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "large-3 columns large-centered text-centered panel-title"
  }, [_vm._v("\n                    Actions des joueurs :\n                ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "row columns "
  }, [_c('playerReportEditor', {
    ref: "preditor",
    attrs: {
      "team_id": _vm.teamid,
      "team_report_id": _vm.id
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.matchReport.is_db_report) ? [(_vm.teamReport.inducement != 'None') ? [_c('div', {
    staticClass: "row columns "
  }, [_c('starReportEditor', {
    ref: "sreditor",
    attrs: {
      "team_id": _vm.teamid,
      "team_report_id": _vm.id
    }
  })], 1), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.detailedTeam && _vm.detailedTeam.rostered_star_player) ? _c('div', {
    staticClass: "row columns "
  }, [_c('RosteredStarReportEditor', {
    ref: "rostered_sreditor",
    attrs: {
      "team_report_id": _vm.id,
      "team_id": _vm.teamid,
      "rostered_star_name": _vm.detailedTeam.rostered_star_player.ref_star_player.name,
      "rostered_star_id": _vm.detailedTeam.rostered_star_player.id
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [(_vm.error_msg) ? _c('div', {
    staticClass: "large-8 columns large-centered error-lbl"
  }, [_vm._v("\n                        " + _vm._s(_vm.error_msg) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-2 columns large-offset-4"
  }, [_c('button', {
    staticClass: "full-width light-grey-button",
    on: {
      "click": _vm.previous
    }
  }, [_vm._v("précédent")])]), _vm._v(" "), _c('div', {
    staticClass: "large-2 columns end"
  }, [_c('button', {
    staticClass: "full-width",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Suivant")])])])], 2)] : _c('div', [_c('spinner')], 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-8 columns large-centered note"
  }, [_vm._v("\n                    NB : la colonne agressions concerne les agressions "), _c('strong', [_vm._v("réussies")]), _vm._v(" uniquement.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "large-8 columns large-centered note"
  }, [_vm._v("\n                NB2 : la colonne "), _c('strong', [_vm._v("XP Bonus")]), _vm._v(" est là pour gérer tous les trucs chelous des prières de nuffle, sans pourrir nos chères stats.\n              ")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "large-3 columns"
  }, [_c('div', {
    staticClass: "note"
  }, [_vm._v("les champs marqués d'un * sont optionnels")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6be9a789"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/match-reports/mr-step-3.vue
// module id = 760
// module chunks = 0